const tabJSON = {
    tabs: [
        // {
        //     type: 'mB',
        //     title: 'My Bot',
        //     default: false,
        //     isEnabled: true
        // },
        // {
        //     type: 'ast',
        //     title: 'Assist',
        //     default: true,
        //     isEnabled: true
        // },
        // {
        //     type: 'srch',
        //     title: 'Search',
        //     default: false,
        //     isEnabled: true
        // },
        // {
        //     type: 'trnspt',
        //     title: 'Transcript',
        //     default: false,
        //     isEnabled: true
        // },
        // {
        //     type: 'cl',
        //     title: 'PlayBook',
        //     default: false,
        //     isEnabled: true
        // },
        // {
        //     type: 'cst',
        //     title: 'Custom Tab',
        //     default: false,
        //     isEnabled: true
        // }
    ]
}

export default tabJSON;